import { FORECAST_LENGTH } from '@/coreDomainsModule/constants';
import { IDate, IYearMonth } from '../date';
import { UserAccount } from './users';

/**
 * 内示
 */
type businessForecastStatus = 'unsupported' | 'orderCompleted' | 'supplierForecastCompleted' | 'notCreateOrder' | 'completed';

/**
 * 内示に関する情報
 * @property businessId - 取引ID
 * @property customerAnnounce - 客先内示
 * @property customerAnnounceDaily - 客先内示(日別)
 * @property supplierAnnounce - 仕入先内示
 * @property businessForecastState - 内示のステータス
 */
interface IForecast {
  businessId: string;
  customerAnnounce: IAnnounce[] | undefined; // 客先内示
  customerAnnounceDaily: IAnnounceDaily[] | undefined; // 客先内示(日別)
  supplierAnnounce: IAnnounce[] | undefined; // 仕入先内示
  businessForecastState: businessForecastStatus | undefined;
}

/**
 * 内示
 * @property amount - 内示数量
 */
interface IAnnounce extends IYearMonth {
  amount: number;
  manageInitiatedYearMonth: IYearMonth | undefined; // 客先内示の受領月、仕入先内示の作成月を管理する
  createAt: number | undefined; // 作成日時
  updateAt: number | undefined; // 更新日時
}

/**
 * 日別内示
 * @property amount - 内示数量
 */
interface IAnnounceDaily extends IDate {
  amount: number;
  manageInitiatedYearMonth: IYearMonth | undefined; // 客先内示の受領月を管理する
  createAt: number | undefined; // 作成日時
  updateAt: number | undefined; // 更新日時
}

const forecastProperties = [
  // aggregator.tsで利用する
  'businessId',
  'customerAnnounce',
  'customerAnnounceDaily',
  'supplierAnnounce',
] as const;

/**
 * IForecastであることを保証する
 * @param value　- 任意の値
 */
function isIForecast(value: object): value is IForecast {
  /*TODO: IForecastが持つべきものを明確にする */
  return true;
}

/**
 * 現状は1 ~ 5までベタガキしているが、
 * ts 4.1以降言語更新後は
 *
 *ts version 4.1 からのやつ... tsupdate後対応
 *テンプレートリテラル型
 *
 *type announceKey = \`announce-${number}\`;
 */
type AnnounceKey = 'announce-1' | 'announce-2' | 'announce-3' | 'announce-4' | 'announce-5';

/**
 * AnnounceKey型であることを保証する
 * @param value - 任意の値
 */
const isAnnounceKey = (value: string): value is AnnounceKey => {
  const split = value.split('-');
  return split?.[0] === 'announce' && !Number.isNaN(Number(split?.[1]));
};

/**
 * AnnounceKey型ない時にエラーを投げる
 * @param value - 任意の値
 */
function assertsAnnounceKey(value: string): asserts value is AnnounceKey {
  if (!isAnnounceKey(value)) {
    throw Error('announceKeyに当てはめれません');
  }
  return;
}

/**
 * AnnounceKey型をFORECAST_LENGTH(number型)に基づいて、
 * announce-${number}で生成
 */
const announceKeys = new Array(FORECAST_LENGTH).fill('announce').map((x, i) => {
  const value = x + '-' + (i + 1);
  assertsAnnounceKey(value);
  return value;
});

/**
 * TODO: 構造が未定なので仮
 * 内示の担当者
 */
export type IForecastStaff = {
  forecastStaffId: string | undefined;
  forecastStaffName: string | undefined;
  recoveredForecastCount: number | undefined;
  totalForecastCount: number | undefined;
  latestUpdateAt: IDate | undefined;
};

/**
 * 受領用内示
 * forecastForReceiptId: 受領用内示ID
 * forecastForReceiptName: 受領用内示名
 * forecastForReceiptStaff: 担当者ID
 */
export interface IForecastForReceipt {
  forecastForReceiptId: string;
  forecastForReceiptName: string;
  forecastForReceiptResponsibleUsers: UserAccount[];
  outputRange: number;
}

/**
 * 受領用内示ごとの回収状況サマリ
 */
export interface IForecastForReceiptSummary extends Pick<IForecastForReceipt, 'forecastForReceiptId' | 'forecastForReceiptName'> {
  staffNames: string[];
  keyword: string;
  recoveredForecastCount: number;
  totalForecastCount: number;
  latestUpdateAt: number | null | undefined;
}

export type { IForecast, IAnnounce, IAnnounceDaily, AnnounceKey, businessForecastStatus };
export { forecastProperties, isIForecast, assertsAnnounceKey, announceKeys };
